/**
 * Get Writer Poll
 * @param {string} storyId
 * @param {string} partId
 * @param {string} pollId
 */

const clientAPICall = url => {
  return Promise.resolve(
    $.ajax({
      type: "DELETE",
      url: url,
      xhrFields: {
        withCredentials: true
      }
    })
  );
};

module.exports = function(storyId, partId, pollId) {
  return new Promise(function(resolve, reject) {
    const url = `${
      wattpad?.apiDomain
    }/writing/v1/stories/${storyId}/parts/${partId}/polls/${pollId}`;

    clientAPICall(url)
      .then(data => {
        return resolve(data);
      })
      .catch(err => {
        return reject(err);
      });
  });
};
